import { createApi } from '@reduxjs/toolkit/query/react';
import { TEmailRequest } from '../types/EmailTypes';
import { baseQuery, getBaseQueryWithReauth } from '../baseQueryAuth';

export const EmailApi = createApi({
  reducerPath: 'EmailApi',
  tagTypes: ['Email'],
  baseQuery: getBaseQueryWithReauth(baseQuery),
  endpoints: (build) => ({
    sendEmail: build.mutation<void, TEmailRequest>({
      query: (body: TEmailRequest) => ({
        url: '/resend_landing_email/',
        method: 'POST',
        headers: {},
        body,
      }),
    }),
  }),
});

export const { useSendEmailMutation } = EmailApi;
